import { ref, isRef, onMounted, onUnmounted, watch } from 'vue';
import EmblaCarousel from 'embla-carousel';

function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function sortAndMapPluginToOptions(plugins) {
  return plugins.concat().sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  }).map(function (plugin) {
    return plugin.options;
  });
}
function arePluginsEqual(pluginsA, pluginsB) {
  if (pluginsA.length !== pluginsB.length) return false;
  var areEqual = EmblaCarousel.optionsHandler().areEqual;
  var optionsA = sortAndMapPluginToOptions(pluginsA);
  var optionsB = sortAndMapPluginToOptions(pluginsB);
  return optionsA.every(function (optionA, index) {
    var optionB = optionsB[index];
    return areEqual(optionA, optionB);
  });
}

function emblaCarouselVue(options, plugins) {
  if (options === void 0) {
    options = {};
  }
  if (plugins === void 0) {
    plugins = [];
  }
  var areOptionsEqual = EmblaCarousel.optionsHandler().areEqual;
  var storedOptions = ref(isRef(options) ? options.value : options);
  var storedPlugins = ref(isRef(plugins) ? plugins.value : plugins);
  var emblaNode = ref();
  var embla = ref();
  function reInit() {
    if (!embla.value) return;
    embla.value.reInit(storedOptions.value, storedPlugins.value);
  }
  onMounted(function () {
    if (!canUseDOM() || !emblaNode.value) return;
    EmblaCarousel.globalOptions = emblaCarouselVue.globalOptions;
    embla.value = EmblaCarousel(emblaNode.value, storedOptions.value, storedPlugins.value);
  });
  onUnmounted(function () {
    if (embla.value) embla.value.destroy();
  });
  if (isRef(options)) {
    watch(options, function (newOptions) {
      if (areOptionsEqual(storedOptions.value, newOptions)) return;
      storedOptions.value = newOptions;
      reInit();
    });
  }
  if (isRef(plugins)) {
    watch(plugins, function (newPlugins) {
      if (arePluginsEqual(storedPlugins.value, newPlugins)) return;
      storedPlugins.value = newPlugins;
      reInit();
    });
  }
  return [emblaNode, embla];
}
emblaCarouselVue.globalOptions = undefined;

export { emblaCarouselVue as default };
//# sourceMappingURL=embla-carousel-vue.esm.js.map
